/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionGroup, DtpAccordionPanel } from 'dtp-react-components';
import DadosConflitosPeriodos from './DadosConflitosPeriodos';
import { doPost } from '../../../utils/requests';

class ListaConflitosPeriodos extends Component {

  constructor(props) {
    super(props);

    this.state = {
      listaRequerimentosConflitos: [],
      reconhecimentoConflito: null,
      showNoContent: false,
      noContentPrimaryMessage: '',
      noContentSecondaryMessage: '',
    };
  }

  componentDidMount() {
    this.buscarConflitos();
  }

  buscarConflitos = () => {
    const { lista } = this.props;
    if (!lista || lista.length === 0) {
      return;
    }
    // this.buscaConflitosPeriodos(lista);
    this.montarConflitosPeriodos(lista);
  };

  atualizarConflitosPeriodos = (conflitoAtualizado) => {
    this.setState(prevState => {
      const novaLista = prevState.listaRequerimentosConflitos.map(c => {
        if (c.idConflito === conflitoAtualizado.idConflito) {
          return {
            ...c,
            requerimentoCorrente: {
              ...c.requerimentoCorrente,
              nomeAprovador: conflitoAtualizado.nomeAprovador != undefined ? conflitoAtualizado.nomeAprovador : c.requerimentoCorrente.nomeAprovador,
              dataAprovacao: conflitoAtualizado.dataAprovacao != undefined ? conflitoAtualizado.dataAprovacao : c.requerimentoCorrente.dataAprovacao,
              cpfAprovador: conflitoAtualizado.cpfAprovador != undefined ? conflitoAtualizado.cpfAprovador : c.requerimentoCorrente.cpfAprovador,
              inAprovacao: conflitoAtualizado.inAprovacao != undefined ? conflitoAtualizado.inAprovacao : c.requerimentoCorrente.inAprovacao,
            }
          };
        }
        return c;
      });

      this.props.atualizarConflitosPeriodos(novaLista);
      return { listaRequerimentosConflitos: novaLista };
    });
  };

  handleChangeConflitoPeriodos = (changeObj) => {
    this.setState({
      reconhecimentoConflito: changeObj.value,
    });
  }

  extrairValoresParaPesquisar = (lista) => {
    const retorno = [];
    let valor;
    if (lista.length > 0) {
      lista.forEach((item) => {
        if (item.idConflito) {
          retorno.push(Number(item.idConflito));
        }
      });
    }
    return retorno;
  }

  buscaConflitosPeriodos = (lista) => {
    const url = 'requerimentos-compensacao-aposentadoria/conflito-periodos/conflitos';
    const listaPesquisa = this.extrairValoresParaPesquisar(lista);
    const parametro = { lista: listaPesquisa, protocolo: this.props.protocolo };
    doPost(
      url,
      parametro,
      (response) => this.handleSuccessBuscaConflitosPeriodos(response),
      this.handleErrorBuscaconflitosPeriodos
    );
  };

  montarConflitosPeriodos = (lista) => {
    this.handleSuccessBuscaConflitosPeriodos(lista);
  };

  handleSuccessBuscaConflitosPeriodos = (lista) => {
  if (!lista || !Array.isArray(lista)) {
    return;
  }

  let contador = this.state.listaRequerimentosConflitos.length + 1;

  const novosConflitos = lista.map(dados => ({
    contadorConflito: contador++,
    idConflito: dados.idConflito,
    dataCriacaoConflito: dados.dataCriacaoConflito,
    dataResolucao: dados.dataResolucao,
    estadoConflito: dados.estadoConflito,
    cpfResolvedor: dados.cpfResolvedor || '',
    nomeResolvedor: dados.nomeResolvedor || '',

    requerimentoCorrente: {
      protocolo: dados.protocoloCorrente,
      nomeAprovador: dados.nomeAprovadorCorrente,
      dataAprovacao: dados.dataAprovacaoCorrente,
      cpf: dados.cpfCorrente,
      cpfAprovador: dados.cpfAprovadorCorrente,
      inAprovacao: dados.inAprovacaoCorrente,
      beneficiario: dados.beneficiarioCorrente,
      matricula: dados.matriculaCorrente,
      codigoSolicitante: dados.codigoSolicitanteCorrente,
      cnpjDestinatario: dados.cnpjDestinatario,
      nomeSolicitante: dados.nomeSolicitanteCorrente,
      codigoDestinatario: dados.codigoDestinatarioCorrente,
      nomeDestinatario: dados.nomeDestinatarioCorrente,
      estado: dados.estadoCorrente,
      estadoConflito: dados.estadoConflito,
      dataInicioBeneficio: dados.dataInicioBeneficioCorrente,
      dataIngresso: dados.dataIngressoCorrente,
      dataDesvinculacao: dados.dataDesvinculacaoCorrente,
      nuTempoContribRo: dados.nuTempoContribRoCorrente,
      dataCessacao: dados.dataCessacaoBeneficioCorrente,
      motivoCessacao: dados.idMotivoRequerimentoCorrente,
      nomeMotivoRequerimento: dados.nomeMotivoRequerimentoCorrente,
      veioPreenchidoDoBanco: !!dados.nomeAprovadorCorrente && !!dados.dataAprovacaoCorrente,
    },

    requerimentoConflitante: {
      protocolo: dados.protocoloConflito,
      nomeAprovador: dados.nomeAprovadorConflito,
      dataAprovacao: dados.dataAprovacaoConflito,
      cpf: dados.cpfConflito,
      beneficiario: dados.beneficiarioConflito,
      matricula: dados.matriculaConflito,
      codigoSolicitante: dados.codigoSolicitanteConflito,
      cnpjSolicitante: dados.cnpjSolicitante,
      nomeSolicitante: dados.nomeSolicitanteConflito,
      codigoDestinatario: dados.codigoDestinatarioConflito,
      nomeDestinatario: dados.nomeDestinatarioConflito,
      estado: dados.estadoConflitoConflitante,
      estadoConflito: dados.estadoConflito,
      dataInicioBeneficio: dados.dataInicioBeneficioConflito,
      dataIngresso: dados.dataIngressoConflito,
      dataDesvinculacao: dados.dataDesvinculacaoConflito,
      nuTempoContribRo: dados.nuTempoContribRoConflito,
      dataCessacao: dados.dataCessacaoBeneficioConflito,
      motivoCessacao: dados.idMotivoRequerimentoConflito,
      nomeMotivoRequerimento: dados.nomeMotivoRequerimentoConflito,
      veioPreenchidoDoBanco: !!dados.nomeAprovadorConflito && !!dados.dataAprovacaoConflito,
    },

    conflitosPeriodos: this.montarListaConflitos(
      dados.requerimentosPeriodosConflitantes
    ),
  }));

  this.setState(prevState => {
    const novaLista = [
      ...prevState.listaRequerimentosConflitos,
      ...novosConflitos
    ];

    this.props.atualizarConflitosPeriodos(novaLista);

    return { listaRequerimentosConflitos: novaLista };
  });
};

  montarListaConflitos = (lista = []) => {
    return lista.map((periodo) => ({
      idPeriodoCorrente: this.verificarIdVazio(periodo.idPeriodoCorrente),
      periodoReqCorrente: `${this.verificarDataVazia(periodo.dataInicioPeriodoCorrente)} - ${this.verificarDataVazia(periodo.dataFimPeriodoCorrente)}`,
      idPeriodoConflito: this.verificarIdVazio(periodo.idPeriodoConflito),
      periodoReqConflito: `${this.verificarDataVazia(periodo.dataInicioPeriodoConflito)} - ${this.verificarDataVazia(periodo.dataFimPeriodoConflito)}`,
      periodoConflito: `${this.verificarDataVazia(periodo.dataInicioConflito)} - ${this.verificarDataVazia(periodo.dataFimConflito)}`,
    }));
  };

  verificarIdVazio = (id) => {
    return (id != null && id !== undefined && id != '') ? id : '';
  }

  verificarDataVazia = (data) => {
    return (data != null && data !== undefined && data != '') ? data : '__/__/____';
  }

  handleErrorBuscaconflitosPeriodos = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar os conflitos de períodos.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  render() {
    const { listaRequerimentosConflitos } = this.state;
    return (
      <DtpAccordionGroup>
        {listaRequerimentosConflitos.map((item, index) => (
          <DtpAccordionPanel
            key={`${item.contadorConflito}-${index}`}
            headingId="conflito"
            panelId={`${item.contadorConflito}-${index}`}
            icon="ico-alert"
            title={`Conflito ${item.contadorConflito} |
            Solicitante ${item.requerimentoConflitante.nomeSolicitante} - ${item.requerimentoConflitante.codigoSolicitante} |
            Destinatário ${item.requerimentoConflitante.nomeDestinatario} - ${item.requerimentoConflitante.codigoDestinatario}
            ${item.requerimentoConflitante.codigoSolicitante !== '01000' ? ` | Matrícula ${item.requerimentoConflitante.matricula}` : ''}`}
          >
            <DadosConflitosPeriodos
              conflitoPeriodos={item}
              handleChange={this.handleChangeConflitoPeriodos}
              atualizarConflitosPeriodos={this.atualizarConflitosPeriodos}
              acao={this.props.acao}
            />
          </DtpAccordionPanel>
        ))}
      </DtpAccordionGroup>
    );
  }
}

ListaConflitosPeriodos.propTypes = {
  lista: PropTypes.array,
  atualizarConflitosPeriodos: PropTypes.func,
  protocolo: PropTypes.string,
};

export default ListaConflitosPeriodos;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/ListaConflitosPeriodos.jsx